import { render, staticRenderFns } from "./HeaderBar.vue?vue&type=template&id=10f78173"
import script from "./HeaderBar.vue?vue&type=script&lang=ts"
export * from "./HeaderBar.vue?vue&type=script&lang=ts"
import style0 from "./HeaderBar.vue?vue&type=style&index=0&id=10f78173&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports